export const STORY_MAP_TAB_BAR_HOST_ATTR = 'data-story-map-toolbar-host'
export const STORY_MAP_TAB_BAR_SLOT_ATTR = 'data-story-map-toolbar'
const DYNAMIC_TOOLBAR_HOST_ATTR = 'data-dynamic-toolbar-host'
export const STORY_MAP_BOARD_TAB_BAR_HOST_ATTR = 'data-story-map-board-toolbar-host'
export const STORY_MAP_BOARD_TAB_BAR_SLOT_ATTR = 'data-story-map-board-toolbar'
export const PROTOTYPE_TAB_BAR_HOST_ATTR = 'data-prototype-toolbar-host'
export const PROTOTYPE_TAB_BAR_SLOT_ATTR = 'data-prototype-toolbar'
export const FILES_TAB_BAR_HOST_ATTR = 'data-files-toolbar-host'
export const FILES_TAB_BAR_SLOT_ATTR = 'data-files-toolbar'

export const findProjectTabNav = () => {
    const navList = document.querySelectorAll('.ant-tabs-nav')
    if (!navList.length) return null

    return (
        Array.from(navList).find((nav) =>
            nav.textContent?.includes('Story Map')
        ) || navList[navList.length - 1]
    )
}

export const attachTabBarSlot = ({
    hostAttr,
    slotAttr,
    hostClassName,
}) => {
    const nav = findProjectTabNav()
    if (!nav) return null

    let hostNode =
        nav.querySelector(`[${hostAttr}]`) ||
        document.querySelector(`[${hostAttr}]`)

    if (!hostNode) {
        hostNode = document.createElement('div')
        hostNode.setAttribute(hostAttr, 'true')
        hostNode.setAttribute(DYNAMIC_TOOLBAR_HOST_ATTR, 'true')
        hostNode.className = hostClassName
        nav.appendChild(hostNode)
    }

    let slot = hostNode.querySelector(`[${slotAttr}]`)
    if (!slot) {
        slot = document.createElement('div')
        slot.setAttribute(slotAttr, 'true')
        hostNode.appendChild(slot)
    }

    return slot
}

export const removeTabBarHost = (hostAttr) => {
    document
        .querySelector(`[${hostAttr}][${DYNAMIC_TOOLBAR_HOST_ATTR}="true"]`)
        ?.remove()
}
